import { render, staticRenderFns } from "./HDTratamientos.vue?vue&type=template&id=6ff81083&scoped=true"
import script from "./HDTratamientos.vue?vue&type=script&lang=js"
export * from "./HDTratamientos.vue?vue&type=script&lang=js"
import style0 from "./HDTratamientos.vue?vue&type=style&index=0&id=6ff81083&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff81083",
  null
  
)

export default component.exports